import React, { useState, useEffect } from "react";
import { FaMinus, FaPlus } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { AiOutlineStar, AiFillStar } from "react-icons/ai";
import { BsTwitter, BsLinkedin, BsEnvelope } from "react-icons/bs";
import { FaFacebookF, FaWhatsapp } from "react-icons/fa";
import ReactHtmlParser from "react-html-parser";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import RatingList from "../components/SingleProduct/RatingList";
import RatingForm from "../components/SingleProduct/RatingForm";
import SimilarProductSlider from "../components/SingleProduct/SimilarProductSlider";
import { ImageUrl } from "../requestMethods";
import { addToCart } from "../apiCalls/cart";
import { addToWishList } from "../apiCalls/wishlist";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import { BiHeart } from "react-icons/bi";
import { toast } from "react-toastify";

const Product = () => {
  const location = useLocation();
  const productId = location.pathname.split("/")[2];
  const navigate = useNavigate();
  console.log(productId);
  const [quantity, setQuantity] = useState(1);
  const [color, setColor] = useState("");
  const [size, setSize] = useState("");
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.currentUser);

  const product = useSelector((state) =>
    state.products.products.find((product) => product._id === productId)
  );

  const handleQuantity = (type) => {
    if (type === "dec") {
      quantity > 1 && setQuantity(quantity - 1);
      console.log("DEC Quantity", quantity);
    } else {
      setQuantity(quantity + 1);
      console.log("INC Quantity", quantity);
    }
  };



  const [image, setImage] = useState(product);
  const [selectedImg, setSelectedImg] = useState(
    image?.multipleimg[0]?.filename
  );

  console.log(product, "product details");

  const addToCartFunc = async () => {
    if (user) {
      const obj = {
        productId: productId,
        categoryId: product?.categories.map((x) => x._id),
        quantity: quantity,
        price: product?.price,
        color: color,
        size: size,
      };
      addToCart(dispatch, user._id, obj);
    } else {
      toast.error(`🦄 Please Login, Then Add to Cart`);

      setTimeout(() => {
        navigate("/login");
      }, 1000);
    }
  };

  const addToWishListFunc = async () => {
    if (user) {
      const obj = {
        productId: productId,
        categoryId: product?.categories.map((x) => x._id),
        quantity: quantity,
        price: product?.price,
        color: color,
        size: size,
      };
      addToWishList(dispatch, user._id, obj);
    } else {
      toast.error(`🦄 Please Login, Add to Wishlist`);
      setTimeout(() => {
        navigate("/login");
      }, 1000);
    }
  };

  useEffect(() => {
    setImage(product)
    setSelectedImg(image?.mainImg[0]?.filename)
  }, [product])

  return (
    <>
      <Breadcrumb
        activeName={product?.title}
        middleName={"Shop"}
        middleUrl={"/products"}
      />
      <section className="product-details">
        <div className="container">
          <div className="row product-detail-row">
            <div className="col-half product-detail-col">
              <div className="product-detail-image">
                <div className="product-small-images">
                  {image?.multipleimg?.map((smallImg, index) => {
                    return (
                      <img
                        style={{
                          border:
                            selectedImg === smallImg.filename
                              ? "2px solid #3474d4"
                              : "",
                        }}
                        src={`${ImageUrl}` + smallImg?.filename}
                        key={index}
                        alt="image1"
                        className="img-fluid small-img"
                        onClick={() => setSelectedImg(smallImg?.filename)}
                      />
                    );
                  })}
                </div>
                <div className="product-main-image">
                  <img
                    src={`${ImageUrl}` + selectedImg}
                    alt={product?.title}
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div className="col-half product-detail-col">
              <div className="product-detail-content">
                <h3 className="product-detail-title">{product?.title}</h3>
                <div className="product-detail-rating">
                  <div className="product-rate">
                    <AiFillStar className="product-stars" />
                    <p>{product.rating.toFixed(1)}</p>
                  </div>

                  <div className="product-review">
                    <p>{product?.numReviews?.length} Reviews</p>
                  </div>
                </div>
                <div className="product-detail-price">
                  <span>₹ {product?.price}</span>{" "}
                  {product?.oldPrice > 0 ? (
                    <del>₹ {product?.oldPrice}</del>
                  ) : (
                    ""
                  )}
                </div>
                <div>
                  <div className="product-detail-desc">
                    {ReactHtmlParser(product?.desc)}
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1990
                  </div>
                </div>
                <div className="filter-container">
                  {product?.color?.length > 0 ? (
                    <div className="filter-content">
                      <span className="filter-title">Color: </span>
                      {product?.color?.map((c, ind) => (
                        <return>
                          <div className="color-div">
                            <div
                              className="avail-color"
                              key={ind}
                              color={c}
                              onClick={() => setColor(c)}
                              style={{ backgroundColor: c }}
                            >
                              <p></p>
                            </div>
                          </div>
                        </return>
                      ))}
                    </div>
                  ) : (
                    ""
                  )}
                  {product?.size.length > 0 ? (
                    <div className="filter-content">
                      <div className="filter-title">Size: </div>
                      <select onChange={(e) => setSize(e.target.value)}>
                        {product?.size?.map((s, ind) => (
                          <option key={ind}>{s}</option>
                        ))}
                      </select>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="add-container">
                  <div className="amount-container">
                    <FaMinus
                      className="icon"
                      onClick={() => handleQuantity("dec")}
                    />
                    <span>{quantity}</span>
                    <FaPlus
                      className="icon"
                      onClick={() => handleQuantity("inc")}
                    />
                  </div>
                  <button className="btn" onClick={addToCartFunc}>
                    ADD TO CART
                  </button>
                  <div className="wishlist-btn" onClick={addToWishListFunc}>
                    <BiHeart />
                  </div>
                </div>
                <div className="product-social-share">
                  <h4>Share on : </h4>
                  <ul className="product-social-container">
                    <li>
                      <a href="#" className="social-link">
                        <FaFacebookF />
                      </a>
                    </li>

                    <li>
                      <a href="#" className="social-link">
                        <BsTwitter />
                      </a>
                    </li>

                    <li>
                      <a href="#" className="social-link">
                        <BsEnvelope />
                      </a>
                    </li>

                    <li>
                      <a href="#" className="social-link">
                        <BsLinkedin />
                      </a>
                    </li>
                    <li>
                      <a href="#" className="social-link">
                        <FaWhatsapp />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="product-extra-details">
        <div className="container">
          <div className="row">
            <div className="col-full">
              <Tabs>
                <TabList>
                  <Tab>Description</Tab>
                  <Tab>Benefits</Tab>
                  <Tab>Reviews</Tab>
                </TabList>

                <TabPanel>{ReactHtmlParser(product?.desc)}</TabPanel>
                <TabPanel>{ReactHtmlParser(product?.benefits)}</TabPanel>
                <TabPanel>
                  <div className="container">
                    <div className="row rating-row">
                      <div className="rating-data">
                        <RatingList productId={productId} />
                      </div>
                      <div className="rating-form">
                        <RatingForm productId={productId} user={user} />
                      </div>
                    </div>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </div>
      </section>

      <SimilarProductSlider />
    </>
  );
};

export default Product;
